/* eslint-disable jsx-a11y/alt-text */
import './utils/geocoding';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter } from 'react-router-dom';
import './styles/global.css';
import { AppRoutes } from './routes';
import PoliticasUso from './components/Shell/PoliticasUso';

function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
      <PoliticasUso />
    </BrowserRouter>
  );
}

export default App;
